export default __webpack_public_path__ + "static/media/NCJamaica.254346fe.png";